import React from 'react';
import SectionMessage from '@atlaskit/section-message';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
	developerSpaceErrorTitle: {
		id: 'forge-ui.renderer.errorMessages.ForgeDevSpaceErrorMessage.developerSpaceErrorTitle',
		defaultMessage: 'This app is currently unavailable',
		description:
			'Title shown when a Forge app cannot be loaded because the app developer has not finished configuring it.',
	},
	developerSpaceErrorBody: {
		id: 'forge-ui.renderer.errorMessages.ForgeDevSpaceErrorMessage.developerSpaceErrorBody',
		defaultMessage:
			'The app developer needs to complete required setup before this app can become available. Contact your app provider for more information or to request support.',
		description:
			'Body copy shown when a Forge app cannot be loaded because the app developer has not finished configuring it.',
	},
});

export const ForgeDevSpaceErrorMessage = (): React.JSX.Element => {
	const intl = useIntl();

	return (
		<SectionMessage
			title={intl.formatMessage(messages.developerSpaceErrorTitle)}
			appearance="error"
		>
			{intl.formatMessage(messages.developerSpaceErrorBody)}
		</SectionMessage>
	);
};
